import React, { useCallback, useState } from "react";

import Drawer from "veneer/Drawer";
import TextInput from "veneer/TextInput";

import { createFolder } from "cortex/ui/src/fleet/view/media-library/action";
import { useAppDispatch } from "cortex/ui/src/hooks";
import { addErrorMessageAction } from "cortex/ui/src/redux-store/messages/actions";

interface CreateFolderDrawerProps {
  open: boolean;
  onCancel: () => void;
}

export default function CreateFolderDrawer({
  open,
  onCancel,
}: CreateFolderDrawerProps) {
  const dispatch = useAppDispatch();
  const [folderName, setFolderName] = useState<string>("");

  const handleCancel = useCallback(() => {
    setFolderName("");
    onCancel();
  }, [onCancel]);

  const handleCreateFolder = useCallback(async () => {
    if (!folderName.trim()) {
      dispatch(addErrorMessageAction("Folder name cannot be empty"));
      return;
    }
    try {
      await dispatch(createFolder(folderName));
      handleCancel();
    } catch (_err) {
      dispatch(addErrorMessageAction("Failed to create folder"));
    }
  }, [dispatch, folderName, handleCancel]);

  return (
    <Drawer
      commitDisabled={!folderName.trim()}
      onCancel={handleCancel}
      onClose={handleCancel}
      onCommit={() => {
        void handleCreateFolder();
      }}
      open={open}
      title="Add Folder"
    >
      <TextInput
        fullWidth
        label="Enter folder name"
        onChange={(newValue: string | null) => setFolderName(newValue ?? "")}
        value={folderName}
      />
    </Drawer>
  );
}
